<template>
	<section>
		<div v-if="showParentView('page-action')">
			<header-page
				name="actions"
				:title="$route.meta.title"
			/>
			<action-list
				:columns="columns"
				:current-page="currentPage"
				:last-page="table.lastPage"
				:rows="newRows"
				@change-page="changePage"
				@on-delete="loadData('action-list')"
				@on-search="onSearch"
				@open-edit="openEdit"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			/>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
	import actionList from '@/components/actions/action-list';
	import quickActions from '@/components/shared/quick-actions';

	function created() {
		this.params.codeProject = this.codeProject;
		this.loadData('action-list');
	}

	function changePage(page) {
		this.params.page = page;
		this.currentPage = page;
		this.loadData('action-list');
	}

	function newRows() {
		this.table.rows = this.table.rows.map((row) => {
			const newRow = { ...row };
			const keyLanguages = Object.keys(row.languages);
			const firstLang = keyLanguages[0];
			newRow.name = row.languages.es ? row.languages.es.name :
				row.languages[firstLang].name;
			newRow.stringLanguages = keyLanguages.join(' - ');
			return newRow;
		});
		return this.table.rows;
	}

	function onSearch(value) {
		this.params.search = value;
		this.loadData('action-list');
	}

	function openEdit({ id }) {
		this.goTo('page-action-edit', { params: { id } });
	}

	function openModal() {
		this.goTo('page-action-new');
	}

	function data() {
		return {
			actions: [
				{
					id: 1,
					code: 'CA',
					text: 'Crear Acción',
					img: 'https://goo.su/vPOkZAH',
					active: true,
				},
			],
			columns: [
				{ id: 1, name: 'Nombre', checked: true, visible: true },
				{ id: 2, name: 'Código', checked: true, visible: true },
				{ id: 3, name: 'URL Web', checked: true, visible: true },
				{ id: 4, name: 'Fragment Móvil', checked: true, visible: true },
				{ id: 5, name: 'Posición', checked: true, visible: true },
				{ id: 6, name: 'Idiomas', checked: true, visible: true },
				{ id: 7, name: 'Acciones', checked: true, visible: true },
			],
			currentPage: 1,
		};
	}

	export default {
		name: 'page-action',
		components: {
			actionList,
			quickActions,
		},
		computed: {
			newRows,
		},
		created,
		data,
		methods: {
			changePage,
			onSearch,
			openEdit,
			openModal,
		},
		props: {
			codeProject: {
				type: String,
			},
		},
		watch: {
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'page-action') {
						this.params.codeProject = this.codeProject;
						this.loadData('action-list');
					}
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/actions/page-action.vue